<template>
    <div>
        <fieldset>
            <legend>Grupo 2</legend>
            <div class="row" >
                <div class="row" v-if="project.curriculo.lattes"> 
                    <a :href="'/curriculos/lattes/pdf/'+user.id" target='_blank'>Ver Lattes</a>    
                </div>
                <div v-if="editable" class="file-field input-field col s6 m6 l6 xl6">
                    <div class="btn">
                        <span>Lattes</span>
                        <input type="file" title='' :disabled="!editable"  name="lattes" id="lattes" ref="lattes" 
                        @change="lattesOnChange()" accept="application/pdf">
                    </div>
                    <div class="file-path-wrapper">                                                                                                                                                 
                        <input class="file-path validate" :disabled="!editable"  :value="getNamePdf(project.curriculo.lattes)" name="lattes_text" id="lattes_text" type="text">
                    </div>
                </div>
                <div v-else class="file-field input-field col s6 m6 l6 xl6">
                    <input disabled  name="lattes_text" type="text">
                    <a :href="'/curriculos/lattes/pdf/'+user.id">Ver Lattes</a>    
                </div>
                <div class="file-field input-field col s6 m6 l6 xl6">
                    <span>"A ação tem caráter inter-disciplinar, inter-departamental e/ou colaborativo?"</span>
                    <p>
                        <label>
                            <input name="interdisc_interdepto"  id="rdbSim" :value="true" :disabled="!editable" 
                                type="radio"  v-model="interdisciplinar"
                            />
                            <span>Sim</span>
                        </label>
                        <label>
                            <input name="interdisc_interdepto"  id="rdbNao" :disabled="!editable" 
                            type="radio" :value="false" v-model="interdisciplinar" 
                             />
                            <span>Não</span>
                        </label>
                    </p>
                </div>
                
                <div class="row"  v-if="project['interdisciplinar']"> 
                    <colaborador   :editable="editable" />
                </div>
            </div>
          
        </fieldset>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {mapState, mapActions} from 'vuex';
    import * as constantes from '../constantes.js';
    import {validatePDF,verifyCpf,getNamePdf} from '../../utils.js';
    import Colaborador from '../forms/Colaborador.vue';
    export default {
        name:'Group2',
        props:[
            'editable',
            
        ],
        components:{
            Colaborador
        },
        computed:{
            ...mapState(['project']),
            user(){
                return this.project.curriculo.usuario;
            },
            interdisciplinar:{
                get(){
                    return this.project.interdisciplinar;
                },
                set(value){
                    this.project.interdisciplinar=value;
                    this.setProject(this.project);
                    
                }
            }
        },
        methods:{
            ...mapActions(['setProject']),
            getNamePdf,
            validatePDF,
            _clearLattesText(){
                $("#lattes_text").val("");
            },
            lattesOnChange(){
                this.lattes=this.$refs.lattes.files[0];
               var spinner = document.getElementById('spinner');
               spinner.style.display = null;
                if(validatePDF(this.lattes)){
                    let formData=new FormData();
                    formData.append('lattes',this.lattes); 
                    formData.append('curriculo',JSON.stringify(this.project.curriculo));
                    $.ajax({
                        headers:{
                            'X-CSRF-TOKEN':$("meta[name='csrf-token']").attr('content'),
                        },
                        url:'/curriculos/',
                        type:"post",
                        processData:false,
                        contentType:false,
                        data:formData,
                        success:(response)=>{
                            showMsg(response.msg,200)
                            spinner.style.display='none';
                            this.$set(this.project,'curriculo',response.curriculo);
                            this.setProject(this.project);
                            this.$nextTick();
                            
                        },
                        error:(response)=>{
                            setTimeout( ()=>{
                                this._clearLattesText();
                            },100);
                            spinner.style.display='none';
                            showMsg(response.responseText,response.status);
                        
                        }
                    });
                }else{
                    setTimeout( ()=>{
                        
                        this._clearLattesText();
                    },1000);
                    spinner.style.display='none';
                    showMsg("Selecione um arquivo PDF de até 5 MB",400);
                    
                }
                    
                
            },
            
        }
            

        
        
       
        
    }
</script>